document.addEventListener('DOMContentLoaded', function () {
	const sections = document.querySelectorAll('.advanced-dropdowns');
	const ALL_CATEGORY = 'alle';

	sections.forEach((section) => {
		const sectionId = section.getAttribute('data-section-id');
		const accordions = section.querySelectorAll('.accordion-box');
		const categoryHeadings = section.querySelectorAll('.accordions__category-heading');

		const filterDropdown = section.querySelector('#filters-dropdown-' + sectionId);
		const searchInput = section.querySelector('#search-input-' + sectionId);

		if (filterDropdown) {
			filterDropdown.addEventListener('change', function () {
				const category = this.value.replace(/\s+/g, '-');

				accordions.forEach((accordion) => {
					const { category: accordionCategory } = accordion.dataset;
					accordion.style.display =
						category === ALL_CATEGORY || accordionCategory === category || !accordionCategory ? 'block' : 'none';
				});

				categoryHeadings.forEach((heading) => {
					heading.style.display = category === 'alle' || heading.dataset.category === category ? 'block' : 'none';
				});
			});
		}

		if (searchInput) {
			searchInput.addEventListener('input', function () {
				const query = this.value.toLowerCase();
				let categoriesWithResults = new Set();

				accordions.forEach((accordion) => {
					const content = accordion.querySelector('.accordion__with-image').textContent.toLowerCase();
					const title = accordion.querySelector('.accordion__toggle').textContent.toLowerCase();
					const matchesQuery = content.includes(query) || title.includes(query);
					accordion.style.display = matchesQuery ? 'block' : 'none';

					if (matchesQuery) {
						categoriesWithResults.add(accordion.dataset.category);
					}
				});

				categoryHeadings.forEach((heading) => {
					if (categoriesWithResults.has(heading.dataset.category)) {
						heading.style.display = 'block';
					} else {
						heading.style.display = 'none';
					}
				});
			});
		}

		const openAccordionById = (id) => {
			const accordion = document.getElementById(id);
			setTimeout(() => {
				accordion?.querySelector('.accordion__toggle')?.click();
			}, 1000);
		};

		if (window.location.hash) {
			const hash = window.location.hash.substring(1);
			openAccordionById(hash);
		}
	});
});
